/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-20T16:25:58-08:00
* @Email:  daniel@reflexmedia.com
* @Last modified by:   Daniel
* @Last modified time: 2017-03-22T13:29:21-07:00
*/



import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import MsgItem from '../MsgItem';
import { tsSince } from '../../../../common';
import TripMsgItem from '../TripMsgItem';
import moment from 'moment-timezone';

const styles = StyleSheet.create({
  root: {
    padding: '12px 16px 0',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    flex: '1',
  }
});

function checkIfContinous(prevDateTime, currentDateTime){
  //console.log(moment(currentDateTime) - moment(prevDateTime));
  return (moment(currentDateTime) - moment(prevDateTime)) < 100000 ? true : false;
}

class MsgActivity extends Component {

  constructor(props) {
    super(props);
    this.renderConvo = this.renderConvo.bind(this);
  }

  renderConvo() {

    let { myAvatar, messages, userId, profile } = this.props;
    // run through each convo message and build a corresponding message item for each.
      var convoItems = [];
      // //console.log('messageList:', messages);
      for(var i=0;i<messages.length;i++) {
        let msg = messages[i];
        // isSent key signifies that logged in user sent this message.
        let isSent = Boolean(userId == msg.account_id)
        // if isSent is true, show logged in avatar, otherwise show other_profile avatar.
        let avatar = isSent ? myAvatar : profile.avatar.data.urls.profile;
        // check to see if this is a trip message?
        let tripData = (msg.type == 'join_trip') ? msg.trip.data : null;
        // let isContinous = i > 0 && messages[i-1].account_id === msg.account_id ? checkIfContinous(messages[i-1].created_at.date, msg.created_at.date) : false;


        // parse messages as HTML if they are sent form admin.
        let { is_admin } = this.props.account;
        let aMsg = is_admin ? <div className={'admin'} dangerouslySetInnerHTML={{__html: msg.message}} /> : msg.message;

        convoItems.push(
          (tripData ?
            <TripMsgItem
              tripData={tripData}
              key={i}
              isSent={isSent}
              // isContinous={isContinous}
              avatar={avatar}
              timeStamp={tsSince(msg.created_at.date)}
              msgText={msg.message} />
          :
            <MsgItem
            tripData={tripData}
            key={i}
            isSent={isSent}
            // isContinous={isContinous}
            avatar={avatar}
            timeStamp={tsSince(msg.created_at.date)}
            msgText={aMsg}></MsgItem>
          )
        )
      }
      return convoItems;
  }

  componentDidMount() {
    const node = findDOMNode(this);
    node.scrollTop = node.scrollHeight
    node.shouldScrollBottom = false
  }

  componentWillUpdate() {
         const node = findDOMNode(this);
         this.shouldScrollBottom = node.scrollTop + node.offsetHeight === node.scrollHeight;
     }

   componentDidUpdate() {
    if (this.shouldScrollBottom) {
       const node = findDOMNode(this);
       node.scrollTop = node.scrollHeight

    }
   }

  render() {
    //console.log("in msgactivity render()");
    //console.log(this.props.messages);

    return (
      <div className={css(styles.root)}>
        {this.renderConvo()}
      </div>
    );
  }
}



export default MsgActivity;



// WEBPACK FOOTER //
// ./src/components/pages/Mail/MsgActivity/index.jsx